import { useRef } from 'react';
import { useForm } from 'react-hook-form';
import { ExitDetailsFormValues } from '../index';
import { PreviousExitDetails } from '../types';
import { buildFormResetValues } from '../helpers/build-form-reset-values';

/**
 * Hook to manage exit details form state and setup
 */
export const useExitDetailsForm = (
  isEditMode: boolean,
  previousExitDetails: PreviousExitDetails | undefined,
  usersFirmId?: string,
) => {
  const initialCorrectionValues = useRef<ExitDetailsFormValues | null>(null);

  const form = useForm<ExitDetailsFormValues>({
    defaultValues: buildFormResetValues(
      previousExitDetails,
      isEditMode,
      usersFirmId,
    ),
  });

  return {
    form,
    initialCorrectionValues,
  };
};
